import React from 'react';
import { useComment } from '../components/CommentProvider';

function useCurrentModuleProp() {
  const currentPosition = window.location.href;
  const { urlTabMap } = useComment();
  const CurrentModuleProp =
    (Object.entries(urlTabMap).find((e) => {
      if (currentPosition.includes('guidingPrinciples-divestitures')) {
        if (e[0].includes('guidingPrinciples-divestitures')) {
          return true;
        }
        return false;
      }
      return currentPosition.includes(e[0]);
    }) || [])[1] || {};

  return CurrentModuleProp;
}

export default useCurrentModuleProp;
